import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { showToast } from "../../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import { getUserTypeName } from "../../../navigation/adminNavigation";
import PostWizard from "./PostWizard";

const AddPostForm = () => {
  const [services, setServices] = useState([]);
  const [states, setStates] = useState([]);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const authState = useSelector((state) => state.auth);
  const user = authState?.user;
  const token = user?.refreshToken || user?.token;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const serviceRes = await axios.get(`${baseUrl}/all/services`);
        setServices(serviceRes.data.services);

        const stateRes = await axios.post(
          `${baseUrl}/admin/states/1`,
          { page_number: 1, page_size: 1000, order_by: "ASC" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setStates(stateRes.data.states);
      } catch {
        console.error("Error fetching services and states");
      }
    };
    fetchData();
  }, [baseUrl, token]);

  // Called from the review step
  const handleFinalSubmit = async (values) => {
    if (isSubmitting) return;

    const imagesToSend = images.map((img) => ({
      image_url: img.image_url,
      imagePath: img.imagePath,
    }));
    const videosToSend = videos.map((video) => ({
      url_path: video.image_url,
    }));
    const attachmentsToSend = attachments.map((att) => ({
      attachment_url: att.url,
    }));

    const currentUserId = user?.id || user?.user?.id || user?.userDetails?.id;

    const payload = {
      country_name: "India",
      service: values.service,
      state_name: values.state_name,
      city_name: values.city_name,
      description: values.description,
      images: imagesToSend,
      videos: videosToSend,
      attachments: attachmentsToSend,
      property_status_id: 1,
      property_type_id: 1,
      purpose_id: 1,
      user_id: currentUserId,
    };

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${baseUrl}/property/lead/add`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.statusType === "SUCCESS") {
        showToast("Post added successfully", { type: "success" });
        // isSubmitting stays true until the redirect, which also lifts the unsaved-changes warning
        setTimeout(() => {
          const userType = getUserTypeName(authState);
          if (userType === "CUSTOMER") {
            navigate("/customer/my-posts");
          } else if (userType === "PARTNER") {
            navigate("/partner/my-posts");
          } else {
            navigate("/post");
          }
        }, 1500);
      } else {
        // The form is kept as is so nothing the user entered is lost
        setIsSubmitting(false);
        showToast(response.data.text || "Failed to submit Post data", { type: "error" });
      }
    } catch (err) {
      console.error(err);
      setIsSubmitting(false);
      showToast("Failed to add Post data", { type: "error" });
    }
  };

  return (
    <PostWizard
      mode="create"
      initialValues={{
        service_id: "",
        service: "",
        state: "",
        state_name: "",
        city: "",
        city_name: "",
        description: "",
      }}
      services={services}
      states={states}
      media={{ images, videos, attachments, setImages, setVideos, setAttachments }}
      onSubmit={handleFinalSubmit}
      isSubmitting={isSubmitting}
    />
  );
};

export default AddPostForm;
